import { Injectable } from "@angular/core";
import { AppConfigService as AppConfigServiceCore } from "core-kit";

@Injectable({
  providedIn: "root"
})
// legacy imports support
export class AppConfigService extends AppConfigServiceCore {}
